export default {
    namespaced: true,
    state: {
        creditCardBillingInfo: {
            respCode: "",
            respMsg: "",
            billingKey: "",
            financeCode: "",
            financeName: "",
        },
    },
    mutations: {
        reset(state) {
            state.creditCardBillingInfo = {
                respCode: "",
                respMsg: "",
                billingKey: "",
                financeCode: "",
                financeName: "",
            };
        },
        setCreditCardBillingInfo(state, value = {}) {
            state.creditCardBillingInfo = value;
        }
    },
    getters: {
        selectCreditCardBillingInfo: (state) => state.creditCardBillingInfo,
        issuerName: (state) => state.creditCardBillingInfo.financeName,
    },
};
